/* index-object-testimonials-marquee */
initMarquee('.index-object-testimonials-marquee', {
    mobile: {
        duration: 50000,
        gap: 0,
        duplicated: true,
        direction: "left"
    },
    desktop: {
        duration: 60000,
        gap: 0,
        duplicated: true,
        direction: "left",
        pauseOnHover: true
    }
});

document.querySelectorAll('.index-object-testimonials-marquee .js-marquee').forEach((content, index) => {
    if (index > 0) content.setAttribute('aria-hidden', 'true');
});

document.querySelectorAll('[data-testimonials-marquee]').forEach((marquee) => {
    const toggle = marquee.querySelector('[data-testimonials-marquee-toggle]');
    if (!toggle) return;

    const setPaused = (paused) => {
        marquee.dataset.paused = paused ? 'true' : 'false';
        toggle.setAttribute('aria-pressed', String(paused));
        marquee.querySelectorAll('.js-marquee-wrapper').forEach((wrapper) => {
            wrapper.style.animationPlayState = paused ? 'paused' : 'running';
        });
    };

    toggle.addEventListener('click', () => {
        setPaused(marquee.dataset.paused !== 'true');
    });
});
/* index-object-testimonials-marquee */
